import http from './httpService';
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/aircraftDetails"
  
function searchUrl(aircraft_id) {
    return `${apiEndpoint}/${aircraft_id}`;
}

export function getAircraftDetail(aircraft_id) {
    const url = searchUrl(aircraft_id);
    //console.log(url);
    return http.get(url);
        
}

